$(function () {
    $('[data-field-map]').each(function () {
        init($(this), $('[data-field-map-el]', this), $('[data-field-map-label]', this));
    });

    function init($el, $map, $label) {
        var geocoder = new google.maps.Geocoder;
        var defaultLatLng = { lat: 41.551029, lng: -8.428204 };
        var map = new google.maps.Map($map.get(0), {
            center: defaultLatLng,
            zoom: 6
        });
        map.setOptions({draggable: true, zoomControl: true, scrollwheel: false, disableDoubleClickZoom: false});

        var searchBox = new google.maps.places.SearchBox($label.get(0));
        $label.keydown(function (e) {
            if (e.keyCode == 13) {
                e.preventDefault();
                return false;
            }
        });

        if ($label.val() !== '') {
            fromAddressToLocation($label.val()).then(function(location) {
                map.setCenter(location);
                map.setZoom(15);
            })
        }
        else if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(function (position) {
                map.setCenter({ lat: position.coords.latitude, lng: position.coords.longitude });
                map.setZoom(15);
            });
        }

        map.addListener('dragend', function () {
            fromLocationToAddress(map.getCenter()).then(function(address) {
                $label.val(address);
            });
        });

        map.addListener('zoom_changed', function () {
            fromLocationToAddress(map.getCenter()).then(function(address) {
                $label.val(address);
            });
        });

        searchBox.addListener('places_changed', function () {
            var places = searchBox.getPlaces();
            if (places.length == 0) {
                return;
            }
            /* For each place, get the icon, name and location. */
            places.forEach(function (place) {
                if (!place.geometry) {
                    console.log("Returned place contains no geometry");
                    return;
                }
                map.setCenter(place.geometry.location);
                map.setZoom(17);
            });
        });

        /*function getGeoFromAddress() {
            geocoder.geocode({ 'address': $label.val() }, function (results, status) {
                if (status === 'OK') {
                    if (results[0]) {
                        map.setCenter(results[0].geometry.location);
                    } else {
                        console.warn('No results found');
                    }
                } else {
                    console.warn('Geocoder failed due to: ' + status);
                }
            });
        }
        $label.change(getGeoFromAddress);*/

        function fromAddressToLocation(address) {
            return new Promise(function(resolve, reject) {
                geocoder.geocode({ 'address': address }, function (results, status) {
                    if (status === 'OK') {
                        if (results[0]) {
                            resolve(results[0].geometry.location);
                        } else {
                            reject('No results found');
                        }
                    } else {
                        reject('Geocoder failed due to: ' + status);
                    }
                });
            });
        }

        function fromLocationToAddress(location) {
            return new Promise(function(resolve, reject) {
                geocoder.geocode({ 'location': location }, function (results, status) {
                    if (status === 'OK') {
                        if (results[0]) {
                            resolve(results[0].formatted_address)
                        } else {
                            reject('No results found');
                        }
                    } else {
                        reject('Geocoder failed due to: ' + status);
                    }
                });
            });
        }
    }
});